//Auth API
export const authGenerateOTP = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/generate-otp`;
};
export const verifyAuthOTP = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/verify-otp`;
};
export const generateMobileOTP = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/generate-mobile-otp`;
};
export const verifyMobileOTP = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/verify-mobile-otp`;
};
export const generateProfileSignedUrl = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/get-upload-profile-url`;
};
export const completeRegistration = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/complete-profile`;
};
export const logIn = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/login`;
};
export const refreshToken = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/refresh-token`;
};
export const forgotPassword = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/request-password-reset`;
};
export const checkLink = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/validate-reset-token`;
};
export const resetPassword = (data) => {
  return `${process.env.REACT_APP_STAGE}/auth/reset-password`;
};

// Platform invite sent from the CampusMesh admin portal (admin-platform API)
export const verifyPlatformInvite = () => {
  return `${process.env.REACT_APP_STAGE}/admin/user-invites/verify`;
};
export const completePlatformInvite = () => {
  return `${process.env.REACT_APP_STAGE}/admin/user-invites/complete`;
};

export const syncApiConnection = (data) => {
  return `${process.env.REACT_APP_STAGE}/chat/user/sync`;
};

export const resetPasswordnew = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/password/reset`;
};

export const userRegister = () => {
  return `${process.env.REACT_APP_STAGE}/auth/user-register`;
};

export const googleCheck = () => {
  return `${process.env.REACT_APP_STAGE}/auth/google-check`;
};

export const googleComplete = () => {
  return `${process.env.REACT_APP_STAGE}/auth/google-complete`;
};

export const microsoftCheck = () => {
  return `${process.env.REACT_APP_STAGE}/auth/microsoft-check`;
};

export const microsoftComplete = () => {
  return `${process.env.REACT_APP_STAGE}/auth/microsoft-complete`;
};

// Auth Auto Complete API's
export const getInstitutions = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/institutions`;
};
export const getResearchAreas = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/research-areas`;
};
export const getDegree = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/degree`;
};
export const getFieldOfStudy = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/field-of-study`;
};
export const getAcademicTitle = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/academic-title`;
};
export const getWorkPosition = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/work-position`;
};
export const getLevel = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/year-level`;
};
export const getCompany = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/company`;
};
export const getEmpType = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/employment-type`;
};
export const getLocation = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/location`;
};
export const getGeoLocation = (data) => {
  return `${process.env.REACT_APP_STAGE}/location/autocomplete`;
};
export const getShareList = (data) => {
  return `${process.env.REACT_APP_STAGE}/share-urls/list`;
};

export const getGlobalCount = (data) => {
  return `${process.env.REACT_APP_STAGE}/chat/unread-count`;
};
export const getPrivacyPolicyList = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/policy-check`;
};

export const getLeaderBoardList = (data) => {
  return `${process.env.REACT_APP_STAGE}/leaderboard`;
}

export const getReferCode = (data) => {
  return `${process.env.REACT_APP_STAGE}/referrals/track-share`;
};

export const getBadges=(data)=>{
   return `${process.env.REACT_APP_STAGE}/badges/my`;
}

export const getTrackCode=(data)=>{
   return `${process.env.REACT_APP_STAGE}/referrals/generate-code`;
}
export const createPrivacyPolicy = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/policy-create`;
};

export const sendUserLocation=(data) => {
  return `${process.env.REACT_APP_STAGE}/location/user-location`;
};

export const searchUserLocation=(data) => {
  return `${process.env.REACT_APP_STAGE}/location/search`;
};

export const getMapStyleApi = () => {
  return `${process.env.REACT_APP_STAGE}/location/map/style`;
};

// --- FIX: Remove the curly braces {} around z, x, y ---
export const getMapTileApi = (z, x, y) => {
  return `${process.env.REACT_APP_STAGE}/location/map/tile/${z}/${x}/${y}`;
};

export const dragUserLocation=()=>{
  return `${process.env.REACT_APP_STAGE}/location/reverse-geocode?`
}
export const getProjectRole = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/project-research-role`;
};
export const getCertification = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/certifications`;
};
export const getSkills = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/skills`;
};
export const getAllReactions = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/reactions`;
};
export const getMarketPlaceCategories = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/marketplace-categories`;
};
export const getMarketPlaceConditions = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/marketplace-conditions`;
};
export const getMarketPlacePaymentMethods = (data) => {
  return `${process.env.REACT_APP_STAGE}/master/marketplace-payment-options`;
};

// Profile Api's
// Profile of any account type — type is USER | INSTITUTION | EMPLOYER
export const getProfileByType = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile/org/${data.type}/${data.id}`;
};
// Resume (user service)
export const userResume = () => {
  return `${process.env.REACT_APP_STAGE}/user/profile/resume`;
};
export const userResumeUploadUrl = () => {
  return `${process.env.REACT_APP_STAGE}/user/profile/resume/upload-url`;
};
export const getUserProfile = (data) => {
  return getProfileByType({ type: "USER", id: data.userId });
};
export const getUserStudyProfile = (data) => {
  return `${process.env.REACT_APP_STAGE}/profile/stats`;
};
export const deleteUserProfilePhoto = () => {
  return `${process.env.REACT_APP_STAGE}/user/deleteUserProfilePhoto`;
};
export const getUserCountProfile = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/connections-count`;
};
export const getUserCommunityProfile = (data) => {
  return `${process.env.REACT_APP_STAGE}/community/community-joined/count`;
};
export const getProfile = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile`;
};
export const getBio = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/bio`;
};
export const updateBio = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/bio/update-user-bio`;
};

export const getUserEducation = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/education`;
};
export const createUserEducation = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/education/create`;
};
export const updateUserEducation = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/education/update/${data}`;
};
export const deleteUserEducation = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/education/delete/${data}`;
};
export const sendInstitutionChangeOtp = () => {
  return `${process.env.REACT_APP_STAGE}/user/education/institution-change/send-otp`;
};
export const getProfileById = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile-by-id/${data.profileId}`;
};
export const getUserExperience = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/experience`;
};
export const createUserExperience = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/experience/create`;
};
export const updateUserExperience = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/experience/update/${data}`;
};
export const deleteUserExperience = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/experience/delete/${data}`;
};

export const getProjectResearch = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/project-research`;
};
export const createUserProject = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/project-research/create`;
};
export const updateUserProject = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/project-research/update/${data}`;
};
export const deleteUserProject = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/project-research/delete/${data}`;
};

export const getCertificate = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/certification`;
};
export const createUserCertificate = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/certification/create`;
};
export const updateUserCertificate = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/certification/update/${data}`;
};
export const deleteUserCertificate = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/certification/delete/${data}`;
};

export const getAchievement = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/campus-involvement`;
};
export const createUserAchievement = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/campus-involvement/create`;
};
export const updateUserAchievement = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/campus-involvement/update/${data}`;
};
export const deleteUserAchievement = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/campus-involvement/delete/${data}`;
};

export const getSkillsData = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/skills`;
};
export const createUserSkills = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/skills/create`;
};
export const updateUserSkills = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/skills/update/${data}`;
};
export const deleteUserSkills = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/skills/delete/${data}`;
};

export const getProfileSignedUrl = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile/get-presigned-url`;
};
export const updateProfileInfo = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile/update`;
};
export const updateProfilePhoto = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile/update/profile-photo`;
};
export const updateCoverPhoto = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile/update/cover-photo`;
};
export const profileStatus = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile-state`;
};
export const profileDismiss = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/profile/popup-dismiss`;
};


// Connections Api's
export const globalSearch = (data) => {
  return `${process.env.REACT_APP_STAGE}/user/search-v1`;
};
export const headerSearch = (data) => {
  return `${process.env.REACT_APP_STAGE}/search`;
};
export const getMyConnections = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/connections`;
};
export const getNewRequest = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/requests`;
};
export const getAllRequest = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/requests`;
};
export const getSentRequest = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/sent-requests`;
};
export const sendConnection = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/request`;
};
export const cancelRequest = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/cancel-request`;
};
export const connectionAction = (id) => {
  return `${process.env.REACT_APP_STAGE}/connection/requests/${id}/action`;
};
export const removeConnection = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/remove-connection`;
};
export const growConnections = () => {
  return `${process.env.REACT_APP_STAGE}/connection/grow-connections`;
};

export const mutualConnections = (id) => {
  return `${process.env.REACT_APP_STAGE}/connection/mutual-connections/${id}`;
};
export const reportConnection = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/report-block`;
};

export const getNewSuggestionsFromUniversity = () => {
  return `${process.env.REACT_APP_STAGE}/connection/university-suggestions`;
};
export const getrecentuggestionsFromUniversity = () => {
  return `${process.env.REACT_APP_STAGE}/connection/recent-similar-connections`;
};
export const getUniversityConnections = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/university`;
};

// Posts and Draft Api's
export const getPostSignedUrl = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/get-presigned-url`;
};
export const createPost = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/create`;
};
export const createDraft = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/draft`;
};
export const createDraftMedia = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/draft/media`;
};
export const createDraftMediaComplete = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/draft/media`;
};
export const getUserDrafts = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/draft/dashboard`;
};
export const getUserPosts = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/list`;
};
export const getMyPosts = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/my-list`;
};

// Post Comments
export const getPostComments = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/${data.postId}/comments`;
};
export const sendPostComment = (data) => {
  return `${process.env.REACT_APP_STAGE}/post`;
};
export const editPostComment = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/comments/${data.commentId}`;
};
export const deletePostComment = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/comments/${data.commentId}`;
};
export const sendPostReaction = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/react`;
};
export const sendCommentReaction = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/comments/react`;
};
export const getCommentReplies = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/comments/${data.commentId}/replies`;
};

export const bookmarkPost = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/bookmark/toggle`;
};
export const getReactionUsers = (postId) => {
  return `${process.env.REACT_APP_STAGE}/post/${postId}/reactions/users`;
};
export const getReactionSummary = (postId) => {
  return `${process.env.REACT_APP_STAGE}/post/${postId}/reactions/summary`;
};
export const getCommentReactionUsers = (commentId) => {
  return `${process.env.REACT_APP_STAGE}/post/comments/${commentId}/reactions/users`;
};
export const getCommentReactionSummary = (commentId) => {
  return `${process.env.REACT_APP_STAGE}/post/comments/${commentId}/reactions/summary`;
};
export const reportPost = (data) => {
  return `${process.env.REACT_APP_STAGE}/post/report`;
};
export const reportPostComment = (commentId) => {
  return `${process.env.REACT_APP_STAGE}/post/comment/report/${commentId}`;
};
// reportType: POST / COMMENT (each has its own reason ids)
export const getReportReasons = () => {
  return `${process.env.REACT_APP_STAGE}/master/report-reasons`;
};

export const deletePost = (postId) => {
  return `${process.env.REACT_APP_STAGE}/post/delete/${postId}`;
};
// MarketPlace - Return relative paths since baseUrl is handled in RTK Query
export const getListings = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings`;
};
export const getMarketplaceRecommendations = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/recommendation`;
};
export const getListingById = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/${id}`;
};
export const createListing = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings`;
};
export const updateListing = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/${id}`;
};
export const deleteListing = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/${id}`;
};
export const getMarketplaceDrafts = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/drafts`;
};
export const getMarketplaceDraftById = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/drafts/${id}`;
};
export const createMarketplaceDraft = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/drafts`;
};
export const updateMarketplaceDraft = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/drafts/${id}`;
};
export const deleteMarketplaceDraft = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/drafts/${id}`;
};
export const publishMarketplaceDraft = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/drafts/${id}/publish`;
};
export const toggleFavorite = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/favorites/toggle`;
};
export const createInquiry = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/inquiries`;
};
export const createOffer = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/offers`;
};
export const getMyList = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/my-listings`;
};

export const getMyAnalytics = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/my-analytics`;
};
export const getPresignedUrl = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/get-presigned-url`;
};
export const markAsSold = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/${id}/mark-as-sold`;
};
export const getOfferList = () => {
  return `${process.env.REACT_APP_STAGE}/marketplace/list-offers`;
};

export const markOfferRead = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/offers/${id}/read`;
};

export const unpublishmarket = (id) => {
  return `${process.env.REACT_APP_STAGE}/marketplace/listings/${id}/unpublish`;
};

//Latest University Users
// export const getMyInstitution = (data) => {
//   return `${process.env.REACT_APP_STAGE}/connection/my-institutions`;
// };
export const getUserInstitution = (data) => {
  return `${process.env.REACT_APP_STAGE}/connection/institution-recommendation`;
};

export const getNewFromUniversity = () => {
  return `${process.env.REACT_APP_STAGE}/connection/people-you-may-know`;
};

// Study Groups (study-space) API endpoints
export const createStudyGroup = () => {
  return `/study-space/create`;
};

export const updateStudyGroup = (groupId) => {
  return `/study-space/${groupId}`;
};

export const getJoinedStudyGroups = ({ offset, limit, search } = {}) => {
  const params = new URLSearchParams();
  params.append("tab", "JOINED");
  if (offset != null) params.append("offset", offset);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  return `/study-space/list?${params.toString()}`;
};

export const getAllStudyGroups = ({
  offset,
  limit = 20,
  category = "all",
  search = "",
} = {}) => {
  const params = new URLSearchParams();
  params.append("tab", "EXPLORE");
  if (offset != null) params.append("offset", offset);
  if (limit) params.append("limit", limit);
  if (category && category !== "all") params.append("category", category);
  if (search) params.append("search", search);
  return `/study-space/list?${params.toString()}`;
};

export const joinStudyGroup = (groupId) => {
  return `/study-space/${groupId}/join`;
};

export const leaveStudyGroup = (groupId) => {
  return `/study-space/${groupId}/leave`;
};

export const transferGroupOwnership = (groupId) => {
  return `/study-space/${groupId}/transfer-ownership`;
};

export const removeGroupMember = (groupId, memberId) => {
  return `/study-space/${groupId}/members/${memberId}/remove`;
};

export const deleteStudyGroup = (groupId) => {
  return `/study-space/${groupId}`;
};

export const getGroupMessages = (
  groupId,
  { cursor, limit = 20, search } = {}
) => {
  const params = new URLSearchParams();
  if (cursor) params.append("cursor", cursor);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  const queryString = params.toString();
  return `/study-space/${groupId}/messages${queryString ? `?${queryString}` : ""}`;
};

export const sendGroupMessage = (groupId) => {
  return `/study-space/${groupId}/messages`;
};

export const favoriteGroup = (groupId) => {
  return `/study-space/${groupId}/favorite`;
};

export const getFavoriteGroups = ({ offset, limit, search } = {}) => {
  const params = new URLSearchParams();
  params.append("tab", "FAVORITES");
  if (offset != null) params.append("offset", offset);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  return `/study-space/list?${params.toString()}`;
};

export const reactToGroupMessage = (messageId) => {
  return `/study-space/messages/${messageId}/react`;
};

export const editGroupMessage = (messageId) => {
  return `/study-space/messages/${messageId}`;
};

export const deleteGroupMessage = (messageId) => {
  return `/study-space/messages/${messageId}`;
};

export const markMessageRead = (spaceId, messageId) => {
  return `/study-space/${spaceId}/messages/${messageId}/mark-read`;
};

export const pinMessage = (spaceId, messageId) => {
  return `/study-space/${spaceId}/messages/${messageId}/pin`;
};

export const unpinMessage = (spaceId, messageId) => {
  return `/study-space/${spaceId}/messages/${messageId}/unpin`;
};

export const getPinnedMessages = (spaceId) => {
  return `/study-space/${spaceId}/messages/pinned`;
};

export const uploadGroupFile = (groupId) => {
  return `/study-space/${groupId}/files`;
};

export const getGroupFiles = (spaceId, { fileType, limit, offset } = {}) => {
  const params = new URLSearchParams();
  if (fileType) params.append("fileType", fileType);
  if (limit) params.append("limit", limit);
  if (offset != null) params.append("offset", offset);
  const qs = params.toString();
  return `/study-space/${spaceId}/files${qs ? `?${qs}` : ""}`;
};

export const getGroupFilePresignedUrl = () => {
  return `/study-space/get-presigned-url`;
};

export const getGroupDetails = (groupId) => {
  return `/study-space/${groupId}`;
};

export const inviteGroupMembers = (groupId) => {
  return `/study-space/${groupId}/invite`;
};

export const getRequestedGroups = ({ offset, limit, search } = {}) => {
  const params = new URLSearchParams();
  if (offset != null) params.append("offset", offset);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  const qs = params.toString();
  return `/study-space/requests${qs ? `?${qs}` : ""}`;
};

export const getInvitedGroups = ({ offset, limit, search } = {}) => {
  const params = new URLSearchParams();
  if (offset != null) params.append("offset", offset);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  const qs = params.toString();
  return `/study-space/invitations${qs ? `?${qs}` : ""}`;
};

export const getGroupMembers = (groupId) => {
  return `/study-space/${groupId}/members`;
};

export const searchInviteUsers = (spaceId, searchTerm = "") => {
  const params = new URLSearchParams();
  if (searchTerm) params.append("prm", searchTerm);
  const qs = params.toString();
  return `/study-space/${spaceId}/search-invite-users${qs ? `?${qs}` : ""}`;
};

export const forwardMessage = (messageId) => {
  return `/study-space/messages/${messageId}/forward`;
};

export const updateMemberRole = (spaceId, userId) => {
  return `/study-space/${spaceId}/members/${userId}/role`;
};

export const respondToInvitation = (invitationId) => {
  return `/study-space/invitations/${invitationId}/respond`;
};

export const getGroupEvents = (groupId) => {
  return `/study-space/${groupId}/events`;
};

export const createGroupEvent = (groupId) => {
  return `/study-space/${groupId}/events`;
};

export const updateGroupEvent = (groupId, eventId) => {
  return `/study-space/${groupId}/events/${eventId}`;
};

export const deleteGroupEvent = (groupId, eventId) => {
  return `/study-space/${groupId}/events/${eventId}`;
};

// Discussions
export const getDiscussions = (spaceId, { offset, limit, filter, search } = {}) => {
  const params = new URLSearchParams();
  if (offset != null) params.append("offset", offset);
  if (limit) params.append("limit", limit);
  if (filter && filter !== "all") params.append("filter", filter);
  if (search) params.append("search", search);
  const qs = params.toString();
  return `/study-space/${spaceId}/discussions${qs ? `?${qs}` : ""}`;
};

export const getDiscussionDetail = (spaceId, discussionId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}`;
};

export const createDiscussion = (spaceId) => {
  return `/study-space/${spaceId}/discussions`;
};

export const pinDiscussion = (spaceId, discussionId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}/pin`;
};

export const unpinDiscussion = (spaceId, discussionId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}/unpin`;
};

// Returns top-level comments only; each one carries up to 3 preview replies.
export const getDiscussionComments = (spaceId, discussionId, { limit, cursor } = {}) => {
  const params = new URLSearchParams();
  if (limit) params.append("limit", limit);
  if (cursor) params.append("cursor", cursor);
  const qs = params.toString();
  return `/study-space/${spaceId}/discussions/${discussionId}/comments${qs ? `?${qs}` : ""}`;
};

// Paginated replies for one parent comment.
export const getDiscussionCommentReplies = (
  spaceId,
  discussionId,
  commentId,
  { limit, cursor } = {}
) => {
  const params = new URLSearchParams();
  if (limit) params.append("limit", limit);
  if (cursor) params.append("cursor", cursor);
  const qs = params.toString();
  return `/study-space/${spaceId}/discussions/${discussionId}/comments/${commentId}/replies${qs ? `?${qs}` : ""}`;
};

export const editDiscussion = (spaceId, discussionId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}`;
};

export const deleteDiscussion = (spaceId, discussionId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}`;
};

export const addDiscussionComment = (spaceId, discussionId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}/comments`;
};

export const editDiscussionComment = (spaceId, discussionId, commentId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}/comments/${commentId}`;
};

export const deleteDiscussionComment = (spaceId, discussionId, commentId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}/comments/${commentId}`;
};

export const reactToDiscussionComment = (spaceId, discussionId, commentId) => {
  return `/study-space/${spaceId}/discussions/${discussionId}/comments/${commentId}/reactions`;
};

export const initiateGroupCall = (groupId) => {
  return `/study-space/${groupId}/call/initiate`;
};

export const joinGroupCall = (groupId) => {
  return `/study-space/${groupId}/call/join`;
};

export const endGroupCall = (groupId) => {
  return `/study-space/${groupId}/call/end`;
};

export const inviteToGroupCall = (groupId) => {
  return `/study-space/${groupId}/call/invite`;
};

export const getActiveCall = (groupId) => {
  return `/study-space/${groupId}/call/active`;
};

export const getMembersCallTime = (groupId) => {
  return `/study-space/${groupId}/call/members-time`;
};

// Notification
export const getNotificationList = () => {
  return `${process.env.REACT_APP_STAGE}/notification/list`;
};

export const getNotificationUnReadCount = () => {
  return `${process.env.REACT_APP_STAGE}/notification/unread-count`;
};

// ✅ New: Delete notification by ID
export const deleteNotification = (notificationId) => {
  return `${process.env.REACT_APP_STAGE}/notification/delete/${notificationId}`;
};

// ✅ New: read notification by ID
export const readNotification = () => {
  return `${process.env.REACT_APP_STAGE}/notification/read`;
};

// User Preferences - Onboarding
export const getOnboardingConfigsList = () => {
  return `${process.env.REACT_APP_STAGE}/user-preferences/onboarding-configs-list`;
};

export const updateOnboardingConfig = () => {
  return `${process.env.REACT_APP_STAGE}/user-preferences/save-progress`;
};

// Institution (REACT_APP_API_INSTITUTION)
export const getInstitutionAnnouncements = () => {
  return `${process.env.REACT_APP_STAGE}/institution/announcements`;
};
export const getInstitutionAnnouncementById = (announcementId) => {
  return `${process.env.REACT_APP_STAGE}/institution/announcements/${announcementId}`;
};
export const getInstitutionGallery = () => {
  return `${process.env.REACT_APP_STAGE}/institution/gallery`;
};
export const markInstitutionGallerySeen = () => {
  return `${process.env.REACT_APP_STAGE}/institution/gallery/seen`;
};
export const getAnnouncementsUnreadCount = () => {
  return `${process.env.REACT_APP_STAGE}/institution/announcements/unread-count`;
};
export const markAnnouncementsSeen = () => {
  return `${process.env.REACT_APP_STAGE}/institution/announcements/seen`;
};

// Notable alumni (REACT_APP_API_INSTITUTION)
// Profile page (public stories of any college) and My Campus (own college, incl. campus-only)
export const getPublicNotableAlumni = (institutionId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/notable-alumni`;
};
export const getInstitutionBatchmateYears = (institutionId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/batchmates/years`;
};
export const getInstitutionBatchmateCourses = (institutionId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/batchmates/courses`;
};
export const getInstitutionBatchmates = (institutionId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/batchmates`;
};
export const getPublicNotableAlumnus = (institutionId, alumniId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/notable-alumni/${alumniId}`;
};
export const getCampusNotableAlumni = () => {
  return `${process.env.REACT_APP_STAGE}/institution/campus/notable-alumni`;
};
export const getCampusNotableAlumnus = (alumniId) => {
  return `${process.env.REACT_APP_STAGE}/institution/campus/notable-alumni/${alumniId}`;
};

// Campus Voices / testimonials (REACT_APP_API_INSTITUTION)
export const getPublicTestimonials = (institutionId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/testimonials`;
};
export const getPublicTestimonial = (institutionId, testimonialId) => {
  return `${process.env.REACT_APP_STAGE}/institution/institutions/${institutionId}/testimonials/${testimonialId}`;
};
export const getCampusTestimonials = () => {
  return `${process.env.REACT_APP_STAGE}/institution/campus/testimonials`;
};
export const getCampusTestimonial = (testimonialId) => {
  return `${process.env.REACT_APP_STAGE}/institution/campus/testimonials/${testimonialId}`;
};
